module.exports = __webpack_public_path__ + "static/media/ji.61f3fd29.png";